import { createSelector } from 'reselect'

export const selectCountry = (state) => state.country

export const selectCountryData = createSelector([selectCountry], (country) => {
  return country.data
})
